import { logout } from "./user";
import { types } from "../types/types";
import { basicMsg, valMsg } from "./swal_msg";
import { protectedReq } from "../helpers/requestHelper";

import { RESIDENCE_TYPE } from "../constants/constants";

// pedidos del usuario
export const myOrders = (safeSetLoading) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('account/my-orders');
            const body = await resp.json();
            if (body.status)
                dispatch(orderList(body.resp));
            else
                valMsg('warning', 'Mis pedidos',
                'Recargue la página para ver sus pedidos');
            safeSetLoading(e => ({ ...e, _screen: false }));
        } catch (err) {
            safeSetLoading(e => ({ ...e, _screen: false }));
            valMsg('error', 'Mis pedidos',
            'No se pudieron cargar sus pedidos');
        };
    };
};

export const loadMoreOrders = (flag, pageSkip, setLoading) => {
    return async(dispatch) => {
        try {
            const { approved_skip, inactive_skip } = pageSkip;
            const page_skip = flag ? approved_skip : inactive_skip;
            const resp = await protectedReq('account/load-more-orders', {
                flag, page_skip
            }, 'POST');
            const body = await resp.json();
            if (body.status) {
                const { orders } = body.resp;
                dispatch(moreOrders({
                    _class: flag ? 'orders' : 'inactive_orders', orders
                }));
            } else
                valMsg('warning', 'Mis pedidos',
                'Recargue la página para ver sus pedidos');
            setLoading(e => ({ ...e, _button: false }));
        } catch (err) {
            valMsg('error', 'Mis pedidos',
            'No se pudieron cargar sus pedidos');
            setLoading(e => ({ ...e, _button: false }));
        };
    };
};

// pedidos del usuario fueron recuperados
const orderList = (payload) => ({
    type: types.userOrderList, payload
});

// pedido aprobado fue seleccionado
export const orderSelected = (payload) => ({
    type: types.userOrderSelected, payload
});
// pedido inactivo fue actualizado
export const orderUpdated = (payload) => ({
    type: types.userOrderUpdated, payload
});

// se cargaron más pedidos aprobados/inactivos
const moreOrders = (payload) => ({
    type: types.userMoreOrders, payload
});

// direcciones de envío/facturación del usuario
// fill y filled son banderas para saber si completar automáticamente los campos
export const addressesesList = async(
    email, fill, filled, // correo de usuario y banderas
    setShippingValues, setBillingValues,
    setShippingAddresses, setBillingAddresses,
    taxSystemData, CFDIData,
    setTaxSystem, setCFDI
) => {
    try {
        const resp = await protectedReq('account/addresses-list');
        const body = await resp.json();
        if (body.status) {
            const { shipping, billing } = body.resp;
            if (!fill) {
                if (!filled) { // información no llenada
                    const filtered = shipping.find(e => e.by_default);
                    // existe dirección establecida como predeterminada
                    if (filtered)
                        setShippingValues(e => ({
                            ...e, ...filtered, email,
                            residence_type_select: RESIDENCE_TYPE[0]
                        }));
                    else
                        setShippingValues(e => ({
                            ...e, residence_type_select: RESIDENCE_TYPE[0]
                        }));
                } else
                    setShippingValues(e => ({
                        ...e, residence_type_select: RESIDENCE_TYPE[0]
                    }));
            } else {
                // establecer valores de sessionStorage (modificar pedido abandonado)
                const shipping_data = sessionStorage.getItem('shipping-data');
                const billing_data = sessionStorage.getItem('billing-data');
                if (!shipping_data)
                    setShippingValues(e => ({
                        ...e, residence_type_select: RESIDENCE_TYPE[0]
                    }));
                else
                    setShippingValues(e => ({
                        ...e, ...JSON.parse(shipping_data),
                        residence_type_select: RESIDENCE_TYPE[0]
                    }));
                
                if (billing_data) {
                    const MyBilling = JSON.parse(billing_data);
                    // así se puede establecer los valores en select
                    if (MyBilling.rfc.length === 12) { // persona moral
                        const filter1 = taxSystemData.filter(e => e.moral === 'Sí');
                        const filter2 = CFDIData.filter(e => e.moral === 'Sí');
                        setTaxSystem(filter1);
                        setCFDI(filter2);
                    } else if (MyBilling.rfc.length === 13) { // persona física
                        const filter1 = taxSystemData.filter(e => e.fisica === 'Sí');
                        const filter2 = CFDIData.filter(e => e.fisica === 'Sí');
                        setTaxSystem(filter1);
                        setCFDI(filter2);
                    } else {
                        setTaxSystem([]);
                        setCFDI([]);
                    }
                    setBillingValues(e => ({
                        ...e, ...MyBilling
                    }));
                }
            }
            // lista de direcciones
            setShippingAddresses(shipping);
            setBillingAddresses(billing);
        } else {
            setShippingValues(e => ({
                ...e, residence_type_select: RESIDENCE_TYPE[0]
            }));
            if (body.msg === 'server-err')
                valMsg('error', 'Direcciones guardadas',
                'Ocurrió un incidente. Intente de nuevo, por favor');
        }
    } catch (err) {
        // primera opción en tipo de domicilio
        setShippingValues(e => ({
            ...e, residence_type_select: RESIDENCE_TYPE[0]
        }));
        basicMsg('No se pueden mostrar sus direcciones');
    };
};

// verificar contraseña de usuario en /informacion-y-seguridad
export const verifiyPwd = async(pwd) => {
    try {
        // token sesión usuario
        const token = localStorage.getItem('token') || '';
        const resp = await protectedReq('account/verify-pwd', { token, pwd }, 'POST');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'not-match')
                basicMsg("La contraseña no coincide");
            else if (body.msg === 'account-not-found')
                basicMsg("No se encontró su cuenta");
            else if (body.msg === 'no-password')
                basicMsg("Ingrese su contraseña");
            else
                basicMsg("Contraseña no verificada");
        }
        return body;
    } catch (err) {
        basicMsg("No se pudo verificar la contraseña");
        return { status: false };
    };
};

// actualizar contraseña de usuario en /informacion-y-seguridad
export const updatePwd = async(pwd) => {
    try {
        // token sesión usuario
        const token = localStorage.getItem('token') || '';
        const resp = await protectedReq('account/update-pwd', { token, pwd }, 'POST');
        const body = await resp.json();
        if (body.status)
            valMsg('success', 'Contraseña actualizada',
            'Ha actualizado su contraseña con éxito');
        else {
            if (body.msg === 'password-weak')
                basicMsg('Usa al menos 12 caracteres y evita datos personales o patrones comunes');
            else if (body.msg === 'miss')
                basicMsg('No se ha enviado la contraseña');
            else if (body.msg === 'not-found')
                valMsg('warning', 'Actualizar contraseña',
                'No se encontró su usuario');
            else if (body.msg === 'not-match')
                valMsg('warning', 'Actualizar contraseña',
                'La contraseña no coincide');
            else if (body.msg === 'not-updated')
                basicMsg('No se ha enviado la contraseña');
            else if (body.msg === 'server-err')
                valMsg('error', 'Actualizar contraseña',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else valMsg('warning', 'Actualizar contraseña',
                'Inténtelo de nuevo, por favor');
        }
        return body;
    } catch (err) {
        valMsg('error', 'Actualizar contraseña',
        'No se pudo actualizar la contraseña');
        return { status: false };
    };
};

// actualizar información de usuario
export const updateMyData = async(data) => {
    try {
        // token sesión usuario
        const token = localStorage.getItem('token') || '';
        const resp = await protectedReq('account/update-data', { token, ...data }, 'POST');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'account-not-found')
                valMsg('warning', 'Cuenta',
                'No se encontró su usuario');
            else if (body.msg === 'miss')
                basicMsg('Compruebe la información ingresada');
            else if (body.msg === 'server-err')
                valMsg('error', 'Mi cuenta',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else valMsg('warning', 'Mi cuenta',
                'Información no actualizada');
        }
        return body;
    } catch (err) {
        valMsg('error', 'Mi cuenta',
        'No se pudo actualizar tu información');
        return { status: true };
    };
};

// enviar código de 6 dígitos para confirmar usuario y establecer contraseña
export const sendConfirmCode = async(email) => {
    try {
        const resp = await protectedReq('account/send-confirm-code', { email }, 'POST');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'account-not-found')
                basicMsg('No hay una cuenta asociada al correo ingresado');
            else if (body.msg === 'miss')
                basicMsg('No reconocemos su correo electrónico');
            else if (body.msg === 'no-req-done')
                valMsg('warning', 'Código no generado',
                'Intente de nuevo, por favor');
            else if (body.msg === 'email-not-send')
                valMsg('warning', 'Código no enviado',
                'Intente de nuevo, por favor');
            else if (body.msg === 'server-err')
                valMsg('error', 'Código de confirmación',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else basicMsg('Código de confirmación no generado');
        }
        return body;
    } catch (err) {
        basicMsg('No se pudo generar su código de confirmación');
        return { status: false };
    };
};

// confirmar código y establecer contraseña
export const confirmNewPassword = async(data) => {
    try {
        const { flag, ...model } = data;
        const resp = await protectedReq('account/set-up-password', { ...model }, 'POST');
        const body = await resp.json();
        if (body.status) {
            if (flag)
                valMsg('success', 'Cuenta',
                'Ha establecido contraseña en su cuenta');
            } else {
            if (body.msg === 'password-weak')
                basicMsg('Usa al menos 12 caracteres y evita datos personales o patrones comunes');
            else if (body.msg === 'code-not-found')
                basicMsg('El código no es correcto');
            else if (body.msg === 'account-not-found')
                basicMsg('No hay una cuenta asociada al correo ingresado');
            else if (body.msg === 'miss')
                basicMsg('Falta información en la solicitud');
            else if (body.msg === 'server-err')
                valMsg('error', 'Código',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else basicMsg('Contraseña no actualizada');
        }
        return body;
    } catch (err) {
        basicMsg('No se pudo actualizar su contraseña');
        return { status: false };
    };
};

// confirmar código para continuar con eliminación de cuenta
export const confirmCode = async(data) => {
    try {
        const resp = await protectedReq('account/confirm-code', { ...data }, 'POST');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'code-not-found')
                basicMsg('El código no es correcto');
            else if (body.msg === 'miss')
                basicMsg('Falta información en la solicitud');
            else if (body.msg === 'server-err')
                valMsg('error', 'Código',
                'Ocurrió un incidente. Intente de nuevo, por favor');
            else basicMsg('Código no confirmado');
        }
        return body;
    } catch (err) {
        basicMsg('No puede proceder con la operación');
        return { status: false };
    };
};

// remover pedido abandonado de lista
export const removeOrderFromList = (order_num) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('account/remove-order', { order_num }, 'POST');
            const body = await resp.json();
            if (body.status)
                dispatch(orderRemoved(order_num));
            else {
                if (body.msg === 'miss')
                    valMsg('warning', 'Pedido abandonado',
                    'Falta información del pedido');
                else if (body.msg === 'order-not-removed')
                    valMsg('warning', 'Pedido abandonado',
                    'No se puede eliminar este pedido');
                else if (body.msg === 'server-err')
                    valMsg('error', 'Pedido abandonado',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    basicMsg('Pedido no fue eliminado');
            }
        } catch (err) {
            valMsg('error', 'Pedido abandonado',
            'No se pudo eliminar el pedido');
        };
    };
};

// volver a mostrar pedido abandonado en lista (undo)
export const showAgainOrderInList = (order, setData) => {
    return async(dispatch) => {
        try {
            const { order_num } = order;
            const resp = await protectedReq('account/show-order-again', { order_num }, 'POST');
            const body = await resp.json();
            if (body.status) {
                setData(e => ({ ...e, snackbar1: false }));
                dispatch(orderRestored(order));
            } else {
                if (body.msg === 'miss')
                    valMsg('warning', 'Pedido abandonado',
                    'Falta información del pedido');
                else if (body.msg === 'order-not-restored')
                    valMsg('warning', 'Pedido abandonado',
                    'No se puede restaurar este pedido');
                else if (body.msg === 'server-err')
                    valMsg('error', 'Pedido abandonado',
                    'Ocurrió un incidente. Intente de nuevo, por favor');
                else
                    basicMsg('Pedido no fue restaurado');
            }
        } catch (err) {
            valMsg('error', 'Pedido abandonado',
            'No se pudo restaurar el pedido');
        };
    };
};

// usuario decide eliminar su cuenta
export const deleteAccount = (setInterfaceData) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('account/delete-account');
            const body = await resp.json();
            if (body.status) {
                setInterfaceData(e => ({ ...e, open: false, loading: false }));
                dispatch(logout());
            } else {
                setInterfaceData(e => ({ ...e, loading: false }));
                if ([
                    'no-token', 'jwt-error', 'unavailable-token',
                    'invalid-token', 'account-not-found'
                ].includes(body.msg)) {
                    basicMsg("Su sesión expiró");
                    dispatch(logout());
                } else
                    valMsg('warning', 'Cuenta',
                    'No se ha podido eliminar su cuenta');
            }
        } catch (err) {
            setInterfaceData(e => ({ ...e, loading: false }));
            valMsg('error', 'Cuenta',
            'Hubo un error al eliminar su cuenta');
        };
    };
};

// retirar pedido de la lista de pedidos abandonados
export const orderRemoved = (payload) => ({
    type: types.userOrderRemoved, payload
});

export const orderRestored = (payload) => ({
    type: types.userOrderRestored, payload
});
